export const CHANGE_DESIGN_SETTINGS_FIELD = 'CHANGE_DESIGN_SETTINGS_FIELD';
export const CHANGE_DESIGN_FIELD = 'CHANGE_DESIGN_FIELD';
export const RESET_DESIGN_SETTING = 'RESET_DESIGN_SETTING';

export const SAVE_SETTING_DESIGN = 'SAVE_SETTING_DESIGN';
export const SAVE_SETTING_DESIGN_RESULT = 'SAVE_SETTING_DESIGN_RESULT';
